var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profit-loss-drill-through-main"},[_c('div',{staticClass:"drill-through-body"},[(_vm.showTableBox)?_c('TableBox',{attrs:{"title":_vm.tableTitle,"apiEndpoint":"getPNLAnalysis","apiPayload":_vm.payload}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }